module.exports = __webpack_public_path__ + "static/media/empty-survey-list.e3e1c1d0.svg";